import { createAction, props } from '@ngrx/store';

export enum TokenActions {
    INVALIDATE_TOKENS = '[INVALIDATE_TOKENS] Invalidate Tokens',
    INVALIDATE_TOKENS_SUCCESS = '[INVALIDATE_TOKENS_SUCCESS] Invalidate Tokens Successfull',
    CLEAR_INVALIDATE_TOKENS = '[CLEAR_INVALIDATE_TOKENS] Clear Invalidated Tokens Done',
    INVALIDATE_TOKENS_FAILED = '[INVALIDATE_TOKENS_FAILED] Invalidate Tokens Failure',
}

export const InvalidateTokens = createAction(TokenActions.INVALIDATE_TOKENS, props<{ payload: { accessToken: string } }>());

export const ClearInvalidatedToken = createAction(TokenActions.CLEAR_INVALIDATE_TOKENS);

export const InvalidateTokensSuccess = createAction(TokenActions.INVALIDATE_TOKENS_SUCCESS, props<{ msg: string }>());

export const InvalidateTokensFailed = createAction(TokenActions.INVALIDATE_TOKENS_FAILED, props<{ msg: string }>());
